<!-- 工作台 -->
<template>
  <div class="work">
    <a-spin :spinning="spinning">
      <div class="work-loginout" @click="logout">
        <img src="./images/loginout.png" alt="" />
        <span>退出</span>
      </div>
      <div class="work-loginout" @click="dialogVisible = true">
        <img src="/images/icons/pwd.png" alt="" />
        <span>修改密码</span>
      </div>
      <div class="header">
        <div class="header-layout">
          <div class="header-layout-left clearfix">
            <img src="./images/emblem.png" />
            <div class="emblem-title">
              <div class="head-line">国家药品追溯监管系统</div>
              <div class="sub-heading">
                National Drug Traceability Supervision System
              </div>
            </div>
          </div>
          <div class="header-layout-right">
            <div class="user-label">
              <img src="./images/user.png" />
              {{ userInfo.departmentName || "" }}
            </div>
            <div class="time-label">{{ currentTime }}</div>
          </div>
        </div>
      </div>
      <div class="main-warp">
        <div class="main-warp-layout">
          <!-- 通知 -->
          <div class="layout-notice">
            <div style="display: flex; align-items: center; width: 110px">
              <img src="./images/notice.png" />
              <div class="title-notice">重要通知：</div>
            </div>

            <!-- <a-tooltip
              placement="topLeft"
              :title="importNotice.noticeContent"
              arrow-point-at-center
            > -->
            <div class="concent" id="ulll" :class="{ anim: animate == true }">
              <div
                class="notification-list"
                v-for="(item, index) in importNotice"
                :key="index"
              >
                <div
                  @click="
                    item &&
                      item.noticeContent &&
                      handleTableRow(true, item, '3')
                  "
                  class="single_line"
                >
                  {{ item.noticeContent || "" }}
                </div>
              </div>
            </div>
            <!-- </a-tooltip> -->
          </div>

          <div class="warp-concent">
            <div class="warp-concent-left">
              <div class="layout-banner">
                <div class="layout-banner-box">
                  <div
                    class="layout-banner-items"
                    v-for="(item, index) in bannerList"
                    :key="index"
                    @click="item.hasAuth && openApp(item)"
                    :style="{
                      cursor: item.hasAuth ? 'pointer' : 'not-allowed',
                    }"
                    :class="{ 'layout-banner-items-disabled': !item.hasAuth }"
                  >
                    <div class="items-concent">
                      <div class="icon-box">
                        <img
                          :src="
                            index > 5
                              ? getImageUrl(`work_default`)
                              : getImageUrl(`work${index}`) || ''
                          "
                        />
                      </div>
                      <div class="label">{{ item.appName }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 列表 regionLevelCode 账号类型：0-国家，1-省级账号 -->

              <div
                class="notice-module"
                v-if="
                  userInfo.regionLevelCode == '2' ||
                  userInfo.regionLevelCode == '3' ||
                  userInfo.regionLevelCode == '1'
                "
              >
                <div class="notice-module-title">
                  <div class="segmentation"></div>
                  <div class="title">
                    <div class="title-label">通知公告</div>
                  </div>
                </div>
                <div class="notice-module-table" ref="tableBox">
                  <div class="search">
                    <a-form>
                      <a-row :gutter="10">
                        <a-col span="8">
                          <a-form-item label="">
                            <InputText
                              placeholder="请输入关键字查询公告"
                              v-model="params.noticeContent"
                              allowClear
                            />
                          </a-form-item>
                        </a-col>
                        <a-col class="flag" span="8" :offset="8">
                          <a-button @click="onReset"
                            ><a-icon
                              type="reload"
                              style="color: #585d68"
                            />重置</a-button
                          >
                          <a-button type="primary" @click="handleSearch"
                            ><IconSvg iconData="search" />搜索</a-button
                          >
                        </a-col>
                      </a-row>
                    </a-form>
                    <TableList
                      :columns="columns"
                      :tableData="tableData"
                      :loading="loading"
                      :pageInfo="pageBean"
                      @getList="changePage"
                      :scroll="{ y: 'calc(100vh - 860px)' }"
                      class="notice-list"
                    >
                      <div
                        slot="action"
                        slot-scope="record"
                        class="columns-action"
                      >
                        <!-- @click="handleTableRow(true, record.scope, '3')" -->
                        <a-button
                          type="link"
                          @click="handleTableRow(true, record.scope, '3')"
                          >查看</a-button
                        >
                      </div>
                    </TableList>
                  </div>
                </div>
              </div>

              <!-- 国家级 -->
              <div
                class="country-module"
                v-if="userInfo.regionLevelCode == '0'"
              >
                <div class="left">
                  <div class="common-title">
                    <div class="common-title-left">
                      <img src="./images/users.png" />
                      <span>登录统计</span>
                    </div>
                    <div class="common-title-right">
                      <a-select
                        class="reset-select"
                        :value="loginType"
                        @change="handleLoginChange"
                      >
                        <a-icon slot="suffixIcon" type="caret-down" />
                        <a-select-option value="0">登录总人次</a-select-option>
                        <a-select-option value="1">登录总时长</a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="left-concent">
                    <ScreenLine
                      chartId="login-charts"
                      :chartData="chartOption"
                    />
                  </div>
                </div>
                <div class="right">
                  <div class="common-title right-header">
                    <div class="common-title-left">
                      <img src="./images/rank.png" />
                      <span>平均使用排行</span>
                      <img class="tip-icon" src="./images/tip.png" />
                    </div>
                    <div class="common-title-right">
                      <a-select
                        class="reset-select"
                        :value="rankType"
                        @change="handleRankChange"
                      >
                        <a-icon slot="suffixIcon" type="caret-down" />
                        <a-select-option value="">本年</a-select-option>
                        <a-select-option value="1">本月</a-select-option>
                        <a-select-option value="0">本周</a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="right-concent">
                    <div class="concent-box">
                      <div class="loading-common" v-if="rankLoading">
                        <a-spin />
                      </div>

                      <div
                        class="concent-layout"
                        v-for="(item, index) in rankData"
                        :key="index"
                      >
                        <div class="concent-layout-header">
                          {{ index + 1 }}. {{ item.name || "-" }}
                          <span class="msg">{{ item.num || 0 }}小时</span>
                        </div>
                        <div class="progress-bar">
                          <ProgressBar :success="item.success" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="warp-concent-right">
              <!-- 用户信息 -->
              <div class="right-user">
                <div class="right-user-top">
                  <div class="user-top-box">
                    <div class="left">
                      <div class="left-icon">{{ surname || "" }}</div>
                      <a-tooltip
                        placement="topLeft"
                        :title="userLoginData.userRealName"
                        arrow-point-at-center
                      >
                        <div class="user">
                          {{ userLoginData.userRealName || "-" }}
                        </div>
                      </a-tooltip>
                    </div>
                    <div class="right">
                      <el-dropdown trigger="hover">
                        <span class="el-dropdown-link icon-more">
                          <i class="el-icon-more"></i>
                        </span>
                        <!-- <el-dropdown-menu slot="dropdown" class="contry-frop">
                        <el-dropdown-item class="logout">
                          <el-dropdown-item
                            icon="el-icon-edit"
                            @click.native="dialogVisible = true"
                            >修改登录密码</el-dropdown-item
                          >
                        </el-dropdown-item>
                      </el-dropdown-menu> -->
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="user-top-msg">
                    <div
                      class="msg-items"
                      v-for="(item, index) in userLoginMsg"
                      :key="index"
                    >
                      <span class="msg-items-label">{{ item.name }}</span>
                      <span class="msg-items-value">{{
                        userLoginData[item.value] || "-"
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="right-user-concent">
                  <img src="./images/icon.png" class="icon" />
                  <div class="stage-door" @click="openStage">进入管理后台</div>
                </div>
              </div>
              <!-- 相关链接 -->
              <div class="related-links">
                <div class="related-links-title">
                  <img src="./images/link.png" />
                  <span>相关链接</span>
                </div>
                <div class="ad-imgs">
                  <div
                    class="ad-imgs-item"
                    @click="openLink('https://www.nmpaic.org.cn/')"
                  >
                    <img src="./images/ad1.png" />
                  </div>
                  <div
                    class="ad-imgs-item"
                    @click="openLink('https://www.nmpa.gov.cn/')"
                  >
                    <img src="./images/ad2.png" />
                  </div>
                  <div
                    class="ad-imgs-item"
                    @click="openLink('https://www.samr.gov.cn/')"
                  >
                    <img src="./images/ad3.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-warp">
          <div class="footer-top">
            <span>本站由国家药品监督管理局信息中心主办</span>
            <span class="pl20">版权所有 未经许可禁止转载或建立镜像</span>
            <!-- <span class="pl20">邮编：830011</span> -->
          </div>
          <div class="footer-top pt10">
            <span>Copyright © 2008-2021 NMPAIC ALL RIGHTS RESERVED</span>
            <span class="pl10"
              ><img src="../login/images/guo-s.png" />京公网安备
              11010202010537号</span
            >
            <span class="pl10">京ICP备05064905号</span>
          </div>
          <div class="footer-top pt10">
            <span>地址：北京市经济技术开发区广德大街22号院一区4号楼</span>
            <span class="pl40">邮编：100076</span>
            <span class="pl40">联系电话：88331981</span>
          </div>
        </div>
      </div>
    </a-spin>

    <!-- 修改密码 -->
    <UpdateLoginPassword
      :dialogVisible="dialogVisible"
      :closeUserDialog="closeUserDialog"
    />
    <!-- 查看 -->
    <AddEdit
      :modalFlag="modalFlag"
      :modalData="modalData"
      @handleFlag="handleTableRow"
      :modalType="modalType"
    />
    <!-- 编辑用户信息 -->
    <Edit
      :modalFlag="modalUserFlag"
      :modalData="modalUserData"
      @handleFlag="handleUserRow"
    />
    <!-- 回流药提示弹层 -->
    <!-- <Item
      :modalFlag="modalDetailFlag"
      :modalData="modalDetailData"
      @handleFlag="handleTableSee"
    /> -->
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { getNowDate } from "@/config/utils.js";
import InputText from "@/components/form/InputText"; // 输入框组件
import TableList from "@/components/table/TableList"; // 表格组件
import ScreenLine from "@/components/charts/ScreenLine"; // 表格组件
import API from "@/api/work";
import ProgressBar from "./components/ProgressBar.vue";
import UpdateLoginPassword from "@/components/password/update-login-password";
import AddEdit from "../notice-announce/notice-manage/components/Detail.vue";
import Edit from "./components/Edit.vue";
import Item from "./components/Item.vue";
import "./index.less";

export default {
  name: "index",
  components: {
    InputText,
    TableList,
    ProgressBar,
    ScreenLine,
    UpdateLoginPassword,
    AddEdit,
    Edit,
    Item
  },
  data() {
    return {
      scrollInterval: null,
      bannerList: [
        {
          appShortName: "-",
        },
        {
          appShortName: "-",
        },
        {
          appShortName: "-",
        },
        {
          appShortName: "-",
        },
      ], // app展示数据
      userLoginData: {
        registerTime: "", // 注册日期
        loginCount: "", // 登录次数
        userRealName: "", // 姓名
        loginWeekDuration: "", // 本周登录时长
        loginMonthDuration: "", // 月度登录时长
        loginYearDuration: "", // 年度时长
      }, // 用户登陆时长
      userLoginMsg: [
        {
          name: "注册日期：",
          value: "registerTime",
        },
        {
          name: "登录次数：",
          value: "loginCount",
        },
        {
          name: "本周登陆时长(小时)：",
          value: "loginWeekDuration",
        },
        {
          name: "月度登陆时长(小时)：",
          value: "loginMonthDuration",
        },
        {
          name: "年度登陆时长(小时)：",
          value: "loginYearDuration",
        },
      ], // 用户登陆信息
      params: {
        noticeContent: "", // 关键字
      },
      pageBean: {
        // 自定义分页
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
      },
      loading: false, // 是否加载
      tableData: [], // 列表数据
      surname: "", // 登录用户姓氏
      importNotice: [], // 重要通知
      currentTime: "", // 当前时间
      rankType: "", // 排行类型
      rankData: [], // 排行数据列表
      rankLoading: false,
      loginType: "0", // 登陆类型
      chartOption: {},
      jumpUrl: "",
      dialogVisible: false, // 密码弹层
      modalFlag: false, // 弹层状态
      modalData: {}, // 表格选中数据
      modalType: "", // 弹层类型

      modalUserFlag: false, // 弹层状态
      modalUserData: {}, // 表格选中数据

      spinning: false, // 是否加载
      animate: false,

      modalDetailData: {}, // 回流药弹层
      modalDetailFlag: false
    };
  },
  mounted() {
    this.getAppList();
    this.getUserLogin();
    this.handleSearch();
    this.getNotice();
    this.getAvgDurationStatistics();
    this.getLoginDuration();
    this.surname =
      this.userInfo && this.userInfo.userRealName
        ? this.userInfo.userRealName.slice(0, 1)
        : "";
    this.updateCurrentTime();
    setInterval(() => {
      this.updateCurrentTime();
    }, 100);

    // 1HILAEFV074MIS66PFIKSBL1OB0010F8 --- 测试id
    if (
      // this.role.includes("1HILAEFV074MIS66PFIKSBL1OB0010F8") &&
      this.role.includes("1IMHE0H41QQJKB7ML6CJEUK3B800173U") &&
      (!this.userInfo.departmentName ||
        !this.userInfo.userIdCard ||
        !this.userInfo.phone)
    ) {
      this.modalUserFlag = true;
      // this.$alert(
      //   `请前往“进入管理后台”-“管理员用户管理”，查询个人账号，补充完整个人信息。`
      // ).catch(() => {});
    }

    setTimeout(() => {
      // this.getScrollMessage();
    });
    this.getScrollMessage();
  },
  computed: {
    ...mapState(["menus", "userInfo", "role"]),
    columns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          align: "center",
          width: 80,
          ellipsis: true,
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "发布来源",
          dataIndex: "publishOrgName",
          key: "publishOrgName",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "publishOrgName" },
        },
        {
          title: "发布内容",
          dataIndex: "noticeContent",
          key: "noticeContent",
          ellipsis: true,
          scopedSlots: { customRender: "noticeContent" },
        },
        {
          title: "发布时间",
          dataIndex: "updateTime",
          key: "updateTime",
          ellipsis: true,
          width: 170,
          scopedSlots: { customRender: "updateTime" },
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 80,
          align: "right",
          scopedSlots: { customRender: "action" },
        },
        // {
        //   title: "状态",
        //   dataIndex: "deleteFlag",
        //   key: "deleteFlag",
        //   // width: 150,
        //   customRender: (text, record) => {
        //     return {
        //       children: (
        //         <span>
        //           {text === "00" ? "启用" : text === "01" ? "禁用" : ""}
        //         </span>
        //       ),
        //     };
        //   },
        // },
      ];
      return columns;
    },
  },
  methods: {
    scroll() {
      this.animate = true;
      setTimeout(() => {
        this.importNotice.push(this.importNotice[0]);
        this.importNotice.shift();
        this.animate = false;
      }, 220);
    },
    getScrollMessage() {
      setInterval(this.scroll, 5000);
    },
    // 获取当前时间
    updateCurrentTime() {
      const date = new Date();
      // this.currentTime = date.toLocaleString();
      this.currentTime = getNowDate(date, "date");
    },
    // 退出
    logout() {
      let params = {
        gagauthtoken: localStorage.getItem("token"),
      };
      this.spinning = true;

      API.logout(params, (callback) => {
        this.spinning = false;
        if (callback.status == "S") {
          window.clearVuexAlong();

          var host = window.location.host;
          if (host.includes(".goago.cn")) {
            window.location.href = "/login";
            // window.location.href = 'https://zhjg.nmpa.gov.cn/idp/authcenter/ActionAuthChain?entityId=isp'
            // this.$router.push("/login");
          } else {
            window.location.href =
              "https://zhjg.nmpa.gov.cn/idp/authcenter/ActionAuthChain?entityId=isp";
          }
        }
      });
    },
    // 跳转管理后台
    openStage() {
      this.$router.push(this.menus[1].children[0].path);
      // if (this.menus[0].title == "工作台") {
      //   // this.$router.push(this.menus[1].children[0].path);
      //   window.open(this.menus[1].children[0].path, '_blank');
      // } else {
      //   // this.$router.push(this.menus[0].children[0].path);
      //   window.open(this.menus[0].children[0].path, '_blank');
      // }
    },
    // 点击app跳转
    openApp(row) {
      // if(row.appId === '1HEHPFTT1E5O7K00VVPO6NMIL97V48NA') {
      // if(row.appId === '1HEHPFTT1E5O7K00VVPO6NMIL97V48NA') {
        // this.handleTableSee(true, row)
      // } else {
        this.jumpRouter(row);
      // }
    },
    jumpRouter(row) {
      let params = {
        data: {
          params: {
            id: row.appId || "",
          },
        },
      };
      API.getAccessUrlByAppId(params, (callback) => {
        let data = "";
        if (callback.status == "S" && callback.data) {
          data = callback.data;
          this.jumpUrl = data;
          // var a = document.createElement("a");
          // a.setAttribute("href", data);
          // a.setAttribute("target", "_blank");
          // a.setAttribute("id", id);
          // // 防止反复添加
          // if (!document.getElementById(id)) {
          //   document.body.appendChild(a);
          // }
          // a.click();

          window.open(data, "_blank");
        }
      });
    },
    // 展示图片
    getImageUrl(name) {
      return `/images/work-icon/${name}.png`;
    },
    // 展示app接口
    getAppList() {
      API.getUserAppList({}, (callback) => {
        let data = [];
        if (callback.status == "S" && callback.data.length > 0) {
          data = callback.data;
        } else {
          data = [
            {
              iconClass: "",
              appShortName: "-",
            },
            {
              iconClass: "",
              appShortName: "-",
            },
            {
              iconClass: "",
              appShortName: "-",
            },
            {
              iconClass: "",
              appShortName: "-",
            },
          ];
        }
        this.bannerList = data;
      });
    },
    // 用户登录时长
    getUserLogin() {
      API.getUserLoginDuration({}, (callback) => {
        let data = {};
        if (callback.status == "S" && callback.data) {
          data = callback.data;
        }
        this.userLoginData = data;
      });
    },
    // 查询
    handleSearch() {
      this.querySubmit(1);
    },
    getNotice() {
      let params = {
        data: {
          pageBean: {
            pageNum: 1,
            pageSize: 5,
          },
          params: {},
        },
      };
      API.getAllMessageNoticeForUser(params, (callback) => {
        let backData = {},
          arr = [];
        if (callback.status == "S" && callback.data) {
          backData = callback.data;
          arr = backData.list;
        }
        this.importNotice = arr;
      });
    },
    // 列表
    querySubmit(pageNum) {
      this.loading = true;
      let params = {
        data: {
          pageBean: {
            pageNum: pageNum,
            pageSize: this.pageBean.pageSize,
          },
          params: {
            ...this.params,
          },
        },
      };
      API.getAllMessageNoticeForUser(params, (callback) => {
        this.loading = false;
        let list = []; // 数据
        if (callback.status == "S" && callback.data) {
          const backData = callback.data;
          const pageBean = { ...this.pageBean };
          pageBean.total = backData.total || 0;
          pageBean.pageNum = pageNum || 1;
          this.pageBean = pageBean;

          if (Array.isArray(backData.list) && backData.list.length > 0) {
            backData.list.map((item, index) => {
              item.key = index;
            });
            list = backData.list;
          }
          this.tableData = list;
        }
      });
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current || 1;
      this.pageBean.pageSize = page.pageSize || 10;
      this.querySubmit(this.pageBean.pageNum);
    },
    // 重置
    onReset() {
      this.params = {
        noticeContent: "",
      };
      this.handleSearch();
    },
    // 相关链接跳转
    openLink(url) {
      window.open(url, "_blank");
    },
    // 排行选择
    handleRankChange(value) {
      this.rankType = value;
      this.getAvgDurationStatistics();
    },
    // 平均登录时长
    getAvgDurationStatistics() {
      this.rankLoading = true;
      let params = {
        data: {
          params: {
            type: this.rankType,
          },
        },
      };
      API.getAvgDurationStatistics(params, (callback) => {
        let data = [];
        this.rankLoading = false;
        if (callback.status == "S" && callback.data) {
          data = callback.data;
        }
        this.rankData = data;
        this.rankData.map((item) => {
          item.success = Math.floor(item.dataRate / 4.2);
        });
      });
    },
    // 登陆人次选择
    handleLoginChange(value) {
      this.loginType = value;
      this.getLoginDuration();
    },
    // 总人数-统计
    getLoginDuration() {
      let params = {
        data: {
          params: {
            type: this.loginType,
          },
        },
      };
      API.getLoginDurationStatistics(params, (callback) => {
        let dataArr = [];
        let numArr = [];
        if (callback.status == "S" && callback.data) {
          let data = callback.data;
          dataArr = data.map((item) => item.date);
          numArr = data.map((item) => item.num);
        }
        this.chartOption = {
          xAxis: dataArr,
          series: [
            {
              data: numArr,
              type: "line",
              name: this.loginType == "0" ? "登录人次" : "登录时长",
            },
          ],
        };
      });
    },
    closeUserDialog() {
      this.dialogVisible = false;
    },
    // 查看详情
    handleTableRow(flag, row, type) {
      this.modalFlag = flag;
      this.modalData = row || {};
      this.modalType = type;
    },
    // 编辑用户信息
    handleUserRow(flag) {
      this.modalUserFlag = flag;
    },
    // 回流药弹层
    handleTableSee(flag, row) {
      this.modalDetailFlag = flag;
      this.modalDetailData = row || {};

      if(!flag) {
        this.jumpRouter(row)
      }
    },
  },
};
</script>
